import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Landing from "./pages/Landing";
import Admin from "./pages/Admin";
import AdminGate from "./pages/AdminGate";
import ArtistPortfolio from "./pages/ArtistPortfolio";
import SmoothScroll from "./components/SmoothScroll";
import "./App.css";

function App() {
  return (
    <div className="App bg-white text-[#0A0A0A] min-h-screen">
      <BrowserRouter>
        <SmoothScroll>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/portfolio/:artistId" element={<ArtistPortfolio />} />
            <Route path="/admin" element={<AdminGate><Admin /></AdminGate>} />
          </Routes>
        </SmoothScroll>
        <Toaster
          position="bottom-right"
          toastOptions={{
            style: {
              borderRadius: 0,
              border: "1px solid #0A0A0A",
              background: "#FFFFFF",
              color: "#0A0A0A",
              fontFamily: "'Jost', 'Futura', 'Helvetica Neue', sans-serif",
              letterSpacing: "0.04em",
            },
          }}
        />
      </BrowserRouter>
    </div>
  );
}

export default App;
